import jwtDecode from "jwt-decode";

const decodeToken = (token) => {
  const userData = jwtDecode(token);
  const role =
    userData["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];

  const userId =
    userData[
      "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
    ];
  return { role, userId };
};

export default decodeToken;
